document.addEventListener('DOMContentLoaded', function () {
  let activeVideo = null;

  document.querySelectorAll('.elevance-versatile-card').forEach(function (card) {
    const btn = card.querySelector('.elevance-play-btn');
    
     if (btn.dataset.listenerAttached) return;
    btn.dataset.listenerAttached = "true";


    const thumb = card.querySelector('.elevance-video-thumb');
    const videoUrl = card.dataset.videoUrl;

    let video = null;
    let videoCreated = false;

    function resetVideo() {
      if (!video) return;

      video.pause();
      video.currentTime = 0;
      video.style.display = 'none';

      thumb.style.display = 'block';
      btn.style.display = 'flex';
    }

    btn.addEventListener('click', function () {

      
      if (activeVideo && activeVideo !== video) {
        activeVideo.pause();
        activeVideo.currentTime = 0;
        activeVideo.style.display = 'none';

        const prevCard = activeVideo.closest('.elevance-versatile-card');
        prevCard.querySelector('.elevance-video-thumb').style.display = 'block';
        prevCard.querySelector('.elevance-play-btn').style.display = 'flex';
      }

   
      if (!videoCreated) {
        video = document.createElement('video');
        video.className = 'elevance-video-player';
        video.setAttribute('controls', '');
        video.setAttribute('playsinline', '');
        video.style.width = '100%';
        video.style.height = '100%';

        const source = document.createElement('source');
        source.src = videoUrl;
        source.type = 'video/mp4';

        video.appendChild(source);
        card.appendChild(video);

        videoCreated = true;

        video.addEventListener('ended', resetVideo);
        video.addEventListener('pause', function () {
          if (video.currentTime > 0 && !video.ended) {
            resetVideo();
          }
        });
      }

      thumb.style.display = 'none';
      btn.style.display = 'none';
      video.style.display = 'block';

      video.play();
      activeVideo = video;
    });
  });
});